import { InfoIcon } from "@components/icons";
import { CustomTooltip } from "@components/tool-tip";
import DOMPurify from "dompurify";
import { FC, memo } from "react";

interface LabelInfoComponentProps {
  label?: string;
  labelClassName?: string;
  required?: boolean;
  infoText?: string;
  isSanitizedLabel?: boolean;
  iconSize?: string;
  htmlFor?: string;
}

const LabelInfoComponent: FC<LabelInfoComponentProps> = ({
  label,
  required,
  infoText,
  labelClassName,
  isSanitizedLabel,
  iconSize,
  htmlFor,
}) => {
  if (!label) {
    return null;
  }

  const sanitizedLabel = isSanitizedLabel ? DOMPurify.sanitize(label) : undefined;

  return (
    <div className="flex align-items-center w-100" style={{ color: "black" }}>
      <label className={labelClassName} htmlFor={htmlFor}>
        {isSanitizedLabel ? (
          <div dangerouslySetInnerHTML={{ __html: sanitizedLabel ?? "" }} />
        ) : (
          label
        )}{" "}
        {required && <span className="required">*</span>}
      </label>
      {infoText && (
        <div className="info-area">
          <CustomTooltip content={infoText} direction="left">
            <InfoIcon size={iconSize ? iconSize : "16"} />
          </CustomTooltip>
        </div>
      )}
    </div>
  );
};

export const LabelInfo = memo(LabelInfoComponent);
